import { UserRole } from '../../organization/dto/invite-to-organization.dto';

export enum GameAdminCommentCategory {
  PAYMENT_EXTERNAL = 'payment_external',
  GENERAL = 'general',
  ISSUE = 'issue',
  REFUND = 'refund',
}

export type GameAdminCommentDto = {
  id: number;
  content: string;
  category?: GameAdminCommentCategory;
  author: {
    id: string;
    email: string;
    role: UserRole;
  };
  createdAt: string;
  updatedAt: string;
};

export class CreateGameAdminCommentDto {
  content: string;
  category?: GameAdminCommentCategory;
}

export class UpdateGameAdminCommentDto {
  content?: string;
  category?: GameAdminCommentCategory;
}
